export const BasicTwoLines = () => {
  return (
    <>
      <div className="self-center text-sm">
        <hr />
      </div>
      <div className="self-center text-sm">
        <hr />
      </div>
    </>
  );
};
